module.exports = __webpack_public_path__ + "static/portfolio-6-524adfaca4e9dc4214d88cdb41b83b46.jpg";